import { render, staticRenderFns } from "./seckill_goods.vue?vue&type=template&id=08e3cb6e&scoped=true"
import script from "./seckill_goods.vue?vue&type=script&lang=js"
export * from "./seckill_goods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e3cb6e",
  null
  
)

export default component.exports